/** @format */

import { all, call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { LOGIN_URL, TWO_FACTOR, MESSAGING_URL } from 'src/constants/constants.js';

/* sagas from features/ */
import loginSaga from 'src/ui/features/Login/state/loginSaga';
import messagingSaga from 'src/ui/features/Messaging/state/messagingSaga';
import casesSaga from 'src/ui/features/Cases/state/casesSaga';
import documentsSaga from 'src/ui/features/Documents/state/documentsSaga';
import dashboardSaga from 'src/ui/features/Dashboard/state/dashboardSaga';
// TODO Check events saga
export function* checkRoute() {
  const loginState = yield select(state => state.login);
  const routerState = yield select(state => state.router);
  //  if (routerState.location.pathname === TWO_FACTOR && !loginState.userSuccess) return yield put(push(LOGIN_URL));
  // if (routerState.location.pathname === MESSAGING_URL && !loginState.token && !loginState.userInfo) return yield put(push(LOGIN_URL));
}

export default function* rootSaga() {
  yield call(checkRoute);
  yield all([...loginSaga, ...messagingSaga, ...casesSaga, ...documentsSaga, ...dashboardSaga]);
}
